import React, { PropsWithChildren } from "react";
import { Link } from "react-router-dom";
import { Box, SxProps } from "@mui/material";

import { NotificationBannerSlot } from "ui/NotificationBanner/NotificationBannerSlot";

import { useUpdateDocTitle } from "fond/hooks/useUpdateDocTitle";

import { PageCentredContent } from "./PageCentredContent";

import { Description, IconContainer, Logo, PageContainer, Title, Top, TopBox } from "./PageCentred.styles";

interface IProps {
  description?: React.ReactNode;
  rightAdornment?: React.ReactNode;
  icon?: React.ReactNode;
  title?: React.ReactNode;
  sx?: SxProps;
  /**
   * The title to display in the browser tab.
   * If not provided, the title will be used.
   */
  windowTitle?: string;
  bare?: boolean; // If true, the page will not have a background for the center panel
}

const PageCentred: React.FC<PropsWithChildren<IProps>> = ({
  children,
  description,
  rightAdornment,
  icon,
  sx,
  title,
  windowTitle,
  bare = false,
}: PropsWithChildren<IProps>) => {
  let docTitle = "";
  if (windowTitle) {
    docTitle = windowTitle;
  } else if (typeof title === "string") {
    docTitle = title;
  }
  useUpdateDocTitle(docTitle);

  return (
    <PageContainer>
      <NotificationBannerSlot id="banner-slot" />
      <Top>
        <Link to="/" data-testid="link-home">
          <Logo data-testid="fond-home" />
        </Link>
        {rightAdornment && <TopBox>{rightAdornment}</TopBox>}
      </Top>
      <Box>
        <PageCentredContent sx={sx} bare={bare}>
          {icon && <IconContainer disableGutters>{icon}</IconContainer>}
          {title && <Title data-testid="page-header">{title}</Title>}
          {description && <Description>{description}</Description>}
          {children}
        </PageCentredContent>
      </Box>
    </PageContainer>
  );
};

export default PageCentred;
